import { setTreeFlags } from "./flags";

const typeDisplayMap = {
	category: "Категория",
	product: "Продукт",
};

const addTreeRows = (data, ms, doc, path = "") => {
	const name = doc.name || "(нет имени)";
	const children = doc.children || [];

	data.addRow(ms, "productExclusion", {
		key: doc._id,
		list: [
			"",
			name,
			path,
			typeDisplayMap[doc.type],
			doc.type,
			children.map((el) => el._id),
		],
	});

	for (const childDoc of children)
		addTreeRows(data, ms, childDoc, path ? `${path}/${name}` : name);
};

export const loadTree = (data, ms, tree) => {
	data.delList("productExclusion");
	addTreeRows(data, ms, tree);

	const table = data.curData.values.table.productExclusion;
	const selected = data.curData.values.fld.data;
	for (const row of table.list)
		if (selected.includes(row.key)) setTreeFlags(data, table.list, row, true);
};
